// extracted by mini-css-extract-plugin
module.exports = {"commentList":"mdtcommentstyles_commentList__-xXZw","commentItem":"mdtcommentstyles_commentItem__37Uhx"};